// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__2yer8","page":"styles_page__2YP6H"};